// extracted by mini-css-extract-plugin
module.exports = {"count-wrapper":"Count_count-wrapper__ij8Pf","count-value":"Count_count-value__L96ZP","count-text":"Count_count-text__s_H20"};